import { stringInputSchema } from "@/shared/lib/validation-schemas"

import type { CalculatorFormErrors, CalculatorFormFieldName, CalculatorFormValues } from "./types"

/**
 * Export the shared validation schema for frontend form validation.
 * This ensures consistency between frontend and edge function validation.
 */
export const calculatorFormSchema = stringInputSchema

export const validateField = (
  field: CalculatorFormFieldName,
  value: string,
): string | undefined => {
  const fieldSchema = calculatorFormSchema.shape[field]
  const result = fieldSchema.safeParse(value)

  if (result.success) {
    return undefined
  }

  return result.error.issues[0]?.message
}

export const validateForm = (values: CalculatorFormValues): CalculatorFormErrors => {
  const result = calculatorFormSchema.safeParse(values)

  if (result.success) {
    return {}
  }

  const errors: CalculatorFormErrors = {}

  for (const issue of result.error.issues) {
    const field = issue.path[0]
    if (typeof field === "string" && errors[field as CalculatorFormFieldName] === undefined) {
      errors[field as CalculatorFormFieldName] = issue.message
    }
  }

  return errors
}
